import gql from 'graphql-tag'

export default gql`
  mutation updateSubject ($id: Int!, $email: String, $parent_id: Int, $details: [SubjectDetailInput]) {
    updateSubject (id: $id, input: { email: $email, parent_id: $parent_id, details: $details }) {
      id
      email
      parent {
        detail {
          id
          label
          title
          language_code
        }
      }
      details {
        id
        label
        title
        language_code
      }
    }
}
`



// WEBPACK FOOTER //
// ./src/apollo/graphql/subject/update.js